export default {

  home: state => state.app.home,
  token: state => state.app.token,
  isLogin: state => !!state.app.token,
  // backgroundColor: state => state.app.backgroundColor,
  userInfo: state => state.app.userInfo || {},
  storeItems: state => state.app.storeItems || {},
  goName: state => state.app.goName
};
